namespace $.$$ {

	$mol_style_define( $shm_ba_chart_tags, {
		position: 'relative',
		height: '520px',
		minHeight: '520px',
	} )

}
